export default __webpack_public_path__ + "static/push-hover-11dd5c18b081d663deef4ee9e737efd5.webp";